import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function SingleVerticalGasOil() {
  return (
    <div className="single-vertical-parent">
      <div className="vertical-title">
        <div className="text-900 font-bold text-7xl mb-4 text-center">
          FlexNet Oil & Gas: Powering Energy Operations with 5G Connectivity
        </div>
        <div className="text-700 text-xl mb-6 text-center line-height-3">
          Enhance safety, operational efficiency, and remote monitoring with
          FlexNet’s private 4G/5G networks for oil and gas environments.
        </div>
      </div>
      {/* Hero Section */}
      <div className="grid grid-nogutter surface-section text-800 ">
        <div className="col-12 md:col-6 p-6 text-center md:text-left flex align-items-center">
          <section>
            <span className="block text-6xl font-bold mb-3">
              FlexNet Oil & Gas
            </span>
            <div className="text-6xl text-primary font-bold mb-3">
              Revolutionizing Operations with 5G Connectivity
            </div>
            <p className="mt-0 mb-4 text-700 line-height-3">
              Empower your oil and gas operations with secure, high-speed
              private 4G/5G networks. Improve real-time monitoring, worker
              safety, and data-driven decision-making, even in remote and harsh
              environments.
            </p>
            <button className="flex underline align-items-center mt-4">
              <Link to="/connectivity">Request Demo</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </section>
        </div>
        <div className="col-12 md:col-6 overflow-hidden">
          <img
            src="https://onelayer.com/wp-content/uploads/2024/06/shutterstock_1488370763.jpg"
            alt="hero-1"
            className="md:ml-auto block md:h-full"
            style={{ clipPath: "polygon(8% 0, 100% 0%, 100% 100%, 0 100%)" }}
          />
        </div>
      </div>

      {/* Key Benefits Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-900">Why </span>
          <span className="text-blue-600">FlexNet for Oil & Gas??</span>
        </div>
        <div className="grid justify-center">
          {keyBenefits.map((benefit, index) => (
            <div key={index} className="col-12 md:col-4 mb-4 px-5">
              <span
                className="p-3 shadow-2 mb-3 inline-block surface-card"
                style={{ borderRadius: "10px" }}
              >
                <i className={`${benefit.icon} text-4xl text-blue-500`}></i>
              </span>
              <div className="text-900 text-xl mb-3 font-medium">
                {benefit.title}
              </div>
              <span className="text-700 line-height-3">{benefit.detail}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Use Cases Section */}

      <div className="mb-3 font-bold text-3xl">
        <span className="text-900">FlexNet Oil & Gas </span>
        <span className="text-blue-600">Use Cases</span>
      </div>
      {useCases.map((useCase, index) => (
        <div
          key={index}
          className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center"
        >
          <div className="b-3 font-bold text-2xl mb-3">
            <span className="text-blue-600">Use Case</span>
            {useCase.title}
          </div>
          <div className="text-700 mb-6">{useCase.description}</div>
          <div className="grid">
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">Benefits</div>
              {useCase.benefits.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Devices/Technologies
              </div>
              {useCase.devices.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Applications
              </div>
              {useCase.applications.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <button className="flex underline align-items-center mt-4 vertical-market-link">
              <Link to="/marketplace">Request Access to Marketplace</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </div>
        </div>
      ))}

      {/* Case Studies Testimonias Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-blue-600"> Key Technical Features</span>
        </div>
        <div className="grid justify-center">
          <div className="text-900 text-xl mb-3 font-medium"></div>
          <div className="technical-specifications">
            <div className="text-700 line-height-3 technical-specifications-box text-xl">
              <ul className="list-disc pl-5 mt-3">
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Low-latency communication with high-speed data transfer
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Coverage in remote and offshore locations
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Seamless integration with existing SCADA systems
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Support for mission-critical applications and devices
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Advanced security protocols for data protection
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Call-to-Action Section */}
      <div className="surface-section text-center py-8">
        <div className="text-900 text-3xl font-bold mb-4">
          Ready to Enhance Your Oil & Gas Operations?
        </div>

        <button className="p-button p-button-raised connectivity-request-demo-button p-3">
          <Link to="contact-page">Get in Touch for a Personalized Demo</Link>
        </button>
      </div>
    </div>
  );
}

const keyBenefits = [
  {
    title:
      "Reliable Connectivity and Mobility in Remote and Hazardous Environments",
    detail:
      "Ensure stable communication and network access in oilfields and offshore platforms.",
    icon: "pi pi-globe",
  },
  {
    title: "Real-Time Asset and Worker Monitoring",
    detail:
      "Track critical assets and personnel for enhanced safety and efficiency.",
    icon: "pi pi-map-marker",
  },
  {
    title: "Enhanced Safety Through Advanced Video Analytics",
    detail:
      "Improve security and incident detection with AI-powered surveillance.",
    icon: "pi pi-video",
  },
  {
    title: "Automated Operations and Predictive Maintenance",
    detail:
      "Reduce downtime and optimize equipment performance with IoT analytics.",
    icon: "pi pi-cog",
  },
  {
    title: "Secure Data Transfer with Low-Latency Communication",
    detail:
      "Ensure stable and encrypted data exchange for critical operations.",
    icon: "pi pi-lock",
  },
];

const useCases = [
  {
    title: " 1: Connected Field Operations",
    description:
      "Improve operational efficiency by connecting critical field equipment, pumps, compressors, and pipelines to a private 5G network for real-time monitoring and control.",
    benefits: [
      { title: "Reduce equipment downtime", icon: "pi pi-clock" },
      { title: "Enable predictive maintenance", icon: "pi pi-chart-line" },
      {
        title: "Improve decision-making with real-time data",
        icon: "pi pi-lightbulb",
      },
    ],
    devices: [
      { title: "IoT Sensors", icon: "pi pi-cloud" },
      { title: "Remote Monitoring Units", icon: "pi pi-server" },
      { title: "Edge Servers", icon: "pi pi-database" },
    ],
    applications: [
      { title: "Asset Condition Monitoring", icon: "pi pi-desktop" },
      { title: "Predictive Maintenance", icon: "pi pi-chart-bar" },
    ],
  },
  {
    title: " 2: Mobility and Remote Worker Safety",
    description:
      "Ensure worker safety in remote oilfields with 5G-connected wearable devices, push-to-talk (PTT) radios, and automated emergency response systems.",
    benefits: [
      {
        title: "Enhance worker safety with real-time tracking",
        icon: "pi pi-shield",
      },
      {
        title: "Reliable communication even in remote locations",
        icon: "pi pi-phone",
      },
      {
        title: "Faster emergency response with automated alerts",
        icon: "pi pi-exclamation-circle",
      },
    ],
    devices: [
      { title: "PTT Devices", icon: "pi pi-comments" },
      { title: "Smart Wearables", icon: "pi pi-mobile" },
      { title: "Safety Monitoring Sensors", icon: "pi pi-heart" },
    ],
    applications: [
      { title: "Workforce Safety Platforms", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 3: Video Analytics for Site Monitoring",
    description:
      "Deploy high-resolution cameras with AI-powered analytics for monitoring critical infrastructure, detecting anomalies, and enhancing site security.",
    benefits: [
      { title: "Proactive detection of safety hazards", icon: "pi pi-eye" },
      {
        title: "Reduce manual inspections with automated surveillance",
        icon: "pi pi-video",
      },
      {
        title: "Enhance perimeter security for remote sites",
        icon: "pi pi-lock",
      },
    ],
    devices: [
      { title: "AI Cameras", icon: "pi pi-camera" },
      { title: "Drones", icon: "pi pi-send" },
      { title: "Video Analytics Platforms", icon: "pi pi-microchip" },
    ],
    applications: [
      {
        title: "Smart Surveillance and Monitoring Systems",
        icon: "pi pi-desktop",
      },
    ],
  },
  {
    title: " 4: Automation of Drilling and Refinery Operations",
    description:
      "Automate drilling and refinery processes using 5G-connected robotic systems and IoT-enabled equipment for optimized performance and safety.",
    benefits: [
      {
        title: "Increase operational efficiency and safety",
        icon: "pi pi-cog",
      },
      {
        title: "Reduce human exposure to hazardous environments",
        icon: "pi pi-user-minus",
      },
      {
        title: "Optimize energy consumption with real-time data",
        icon: "pi pi-chart-bar",
      },
    ],
    devices: [
      { title: "Robotics", icon: "pi pi-microchip" },
      { title: "Automated Drilling Equipment", icon: "pi pi-cog " },
      { title: "PLC Systems", icon: "pi pi-server" },
    ],
    applications: [
      { title: "Industrial Automation Solutions", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 5: Remote Inspection with Drones",
    description:
      "Use 5G-connected drones for real-time inspection of pipelines, flare stacks, and offshore platforms, reducing the need for manual checks.",
    benefits: [
      {
        title: "Conduct inspections in hazardous or hard-to-reach areas",
        icon: "pi pi-map",
      },
      { title: "Reduce operational downtime", icon: "pi pi-clock" },
      {
        title: "Improve accuracy with high-resolution imaging",
        icon: "pi pi-camera",
      },
    ],
    devices: [
      { title: "Inspection Drones", icon: "pi pi-send" },
      { title: "High-Res Cameras", icon: "pi pi-camera" },
      { title: "Edge Analytics", icon: "pi pi-microchip" },
    ],
    applications: [
      { title: "Remote Asset Inspection Platforms", icon: "pi pi-desktop" },
    ],
  },
];
